import { instance as axios } from "../axios";
import JWT from 'jsonwebtoken';

// initial state
const state = {
    data: [
        {
            id_mes: 1,
            nome: 'Janeiro'
        },
        {
            id_mes: 2,
            nome: 'Fevereiro'
        },
        {
            id_mes: 3,
            nome: 'Março'
        },
        {
            id_mes: 4,
            nome: 'Abril'
        },
        {
            id_mes: 5,
            nome: 'Maio'
        },
        {
            id_mes: 6,
            nome: 'Junho'
        },
        {
            id_mes: 7,
            nome: 'Julho'
        },
        {
            id_mes: 8,
            nome: 'Agosto'
        },
        {
            id_mes: 9,
            nome: 'Setembro'
        },
        {
            id_mes: 10,
            nome: 'Outubro'
        },
        {
            id_mes: 11,
            nome: 'Novembro'
        },
        {
            id_mes: 12,
            nome: 'Dezembro'
        },
    ]
}

// getters
const getters = {
    getAll:(state)=>{
        return state.data;
    },
    getById: (state) => (id) => {
        if(!id) return;
        return state.data.find((el)=>{ return el.id_mes == id})
    }
}

const actions = {}

const mutations = {}



export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/meses.js